import React from 'react';
import './australia.css'; // Import the CSS for styling

const Australia = () => {
  return (
    <div className="australia-page">
      <header className="australia-header">
        <h1>Study in Australia</h1> {/* Ensure the correct title is displayed */}
      </header>
      <main className="australia-content">
        <section className="australia-section">
          <h2>World-Class Education</h2>
          <p>
            Australia is home to some of the top universities in the world, 
            including the University of Melbourne, Australian National University, 
            and the University of Sydney. These institutions are renowned for 
            their academic rigor, research opportunities, and innovative teaching methods.
          </p>
        </section>
        <section className="australia-section">
          <h2>Cultural Diversity</h2>
          <p>
            Australia welcomes students from all over the globe, making it a melting 
            pot of cultures, traditions, and perspectives. This multicultural 
            environment enriches the learning experience and helps students develop 
            a global outlook.
          </p>
        </section>
        <section className="australia-section">
          <h2>Post-Study Work Opportunities</h2>
          <p>
            International students in Australia can work part-time while studying 
            and have the opportunity to stay and work in the country after graduation, 
            allowing them to gain valuable work experience.
          </p>
        </section>
        
      </main>
      <footer className="australia-footer">
        <p>Explore the opportunities that await you in Australia!</p>
      </footer>
    </div>
  );
};

export default Australia;
